// Options are UI, not indexable content. Never move navigation or profile links here.
(() => {
    const registry = document.querySelector('[data-gallery-options]');
    if (!registry) return;

    const fields = {
        incall_location: ['incall-location', 'incall_location[]', 'Location', 'fbarLocList'],
        services: ['service', 'service[]', 'Services', 'fbarSvcList'],
        category: ['category', 'category[]', 'Type', 'fbarCatList'],
        hair_colour: ['hair_colour', 'hair_colour[]', 'Hair colour', 'fbarHairList'],
        nationality: ['nationality', 'nationality[]', 'Nationality', 'fbarNationalityList'],
        dresses: ['dress', 'dress[]', 'Dress size', 'fbarDressList'],
        busts: ['bust', 'busts[]', 'Bust', 'fbarBustList'],
        prices: ['price', '', 'Price'], ages: ['age', '', 'Age'],
        fetishes: ['fetish', 'fetishes[]', 'Fetishes'],
        toys: ['toy', 'toys[]', 'Toys'], all_fetishes: ['fetish-all', 'all_fetishes[]', 'Fetishes']
    };
    const cache = new Map();
    const pending = new Map();
    const rangeEdits = {};
    let serial = 0;
    let refreshTimer;

    const values = key => Array.from(new Set(Array.from(
        document.querySelectorAll(`input[name="${fields[key][1]}"]:checked`)
    ).map(input => input.value)));

    function state() {
        const params = new URLSearchParams(window.location.search);
        const result = {};
        Object.keys(fields).forEach(key => {
            const selected = fields[key][1] ? values(key) : (rangeEdits[key] ?? (params.get(key) || '').split(',').filter(Boolean));
            if (selected.length) result[key] = selected.join(',');
        });
        if (document.querySelector('input.available:checked')) result.available = '1';
        if (registry.dataset.baseCategory) result.base_category = registry.dataset.baseCategory;
        if (registry.dataset.baseService) result.base_service = registry.dataset.baseService;
        if (registry.dataset.location) {
            result.location = registry.dataset.location;
            result.location_call_mode = document.querySelector('input.location-call-mode:checked')?.value
                || params.get('location_call_mode') || 'outcall';
        }
        return result;
    }

    function requestKey(facet) {
        const current = state();
        delete current[facet];
        return new URLSearchParams({ facet, ...current }).toString();
    }

    function selectionLabel(key) {
        if (!fields[key][1]) return (state()[key] || '').replace(',', '–');
        return values(key).map(value => {
            const input = Array.from(registry.querySelectorAll('input')).find(el => el.name === fields[key][1] && el.value === value);
            return (input?.dataset.smartLabel || value).replace(/^cup:/, '');
        }).join(', ');
    }

    function syncLabels() {
        const classNames = { incall_location: 'loc', services: 'svc', category: 'cat',
            hair_colour: 'hair', nationality: 'nationality', dresses: 'dress', ages: 'age', busts: 'bust' };
        Object.keys(fields).forEach(key => {
            const label = selectionLabel(key);
            document.querySelectorAll(`[data-facet-selection="${key}"]`).forEach(el => { el.textContent = label; });
            const suffix = classNames[key];
            if (suffix) {
                document.querySelectorAll(`.fbar-${suffix}-label`).forEach(el => { el.textContent = label || fields[key][2]; });
                document.querySelectorAll(`.fbar-${suffix}-count`).forEach(el => {
                    const count = fields[key][1] ? values(key).length : (label ? 1 : 0);
                    el.textContent = String(count);
                    el.classList.toggle('d-none', !count);
                });
            }
        });
        const summary = document.querySelector('[data-selected-filter-summary]');
        if (summary) {
            summary.textContent = Object.keys(fields).map(key => {
                const label = selectionLabel(key);
                return label ? `${fields[key][2]}: ${label}` : '';
            }).filter(Boolean).join(' · ');
            summary.hidden = !summary.textContent;
        }
    }

    function canonicalInput(key, value, label) {
        let input = Array.from(registry.querySelectorAll('input')).find(el => el.name === fields[key][1] && el.value === value);
        if (!input) {
            input = document.createElement('input');
            input.type = 'checkbox';
            input.name = fields[key][1];
            input.className = fields[key][0];
            input.value = value;
            input.dataset.gallerySelected = key;
            registry.appendChild(input);
        }
        if (label || !input.dataset.smartLabel) input.dataset.smartLabel = label || value;
        return input;
    }

    function render(host, payload) {
        const facet = host.dataset.galleryFacet;
        host.replaceChildren();
        if (['prices', 'ages'].includes(facet)) {
            const chosen = (state()[facet] || '').split(',');
            const names = facet === 'prices' ? ['price_min', 'price_max'] : ['age_min', 'age_max'];
            names.forEach((name, i) => {
                const label = document.createElement('label');
                label.className = 'd-block text-small my-2';
                label.textContent = i ? 'To ' : 'From ';
                const input = document.createElement('input');
                input.type = 'number';
                input.className = `form-control ${fields[facet][0]}`;
                input.name = name;
                input.min = String(payload.min);
                input.max = String(payload.max);
                input.value = chosen.length === 2 ? chosen[i] : String(i ? payload.max : payload.min);
                label.append(input);
                host.append(label);
            });
            host.classList.add('filter-list');
        } else {
            const ul = document.createElement('ul');
            ul.className = 'filter-list fbar-check-list list-unstyled mb-0';
            ul.id = host.closest('details') ? `advanced-${facet}` : (fields[facet][3] || `facet-${facet}`);
            const options = payload.options.filter(option => facet !== 'busts' || host.closest('details')
                || option.kind !== 'band');
            values(facet).forEach(value => {
                if (!options.some(option => option.value === value)) {
                    options.push({ value, label: canonicalInput(facet, value).dataset.smartLabel, count: 0 });
                }
            });
            options.forEach(option => {
                const key = option.facet || facet;
                const li = document.createElement('li');
                li.className = 'fbar-check-item';
                li.dataset.search = option.label.toLowerCase();
                const input = document.createElement('input');
                input.id = `gallery-option-${++serial}`;
                input.type = 'checkbox';
                input.className = `fbar-check-input ${fields[key][0]}`;
                input.name = fields[key][1];
                input.value = option.value;
                input.dataset.smartLabel = option.label;
                input.checked = values(key).includes(option.value);
                const backing = canonicalInput(key, option.value, option.label);
                // A loaded catalogue may add unchecked backing controls; selection stays independent.
                if (input.checked) backing.checked = true;
                const label = document.createElement('label');
                label.htmlFor = input.id;
                label.className = 'fbar-check-row';
                const box = document.createElement('span');
                box.className = 'fbar-check-box';
                const text = document.createElement('span');
                text.className = 'fbar-check-text';
                text.textContent = option.label;
                const count = document.createElement('span');
                count.className = 'fbar-option-count';
                count.textContent = String(option.count);
                label.append(box, text, count);
                li.append(input, label);
                ul.append(li);
            });
            if (!options.length) ul.textContent = 'No options match the other selected filters.';
            host.append(ul);
        }
        const clear = document.createElement('button');
        clear.type = 'button';
        clear.className = 'btn btn-sm text-favourite mt-2';
        clear.dataset.clearGalleryFacet = facet;
        clear.textContent = 'Clear this filter';
        host.append(clear);
        document.dispatchEvent(new CustomEvent('gallery:filters-hydrated'));
        syncLabels();
    }

    async function load(host, retry = false) {
        const facet = host.dataset.galleryFacet;
        if (!fields[facet]) return;
        const key = requestKey(facet);
        if (!retry && host.dataset.loadedKey === key) return;
        const generation = String(++serial);
        host.dataset.generation = generation;
        host.setAttribute('aria-busy', 'true');
        host.innerHTML = '<span class="spinner-border spinner-border-sm" aria-hidden="true"></span> <span role="status">Loading options…</span>';
        try {
            let payload = !retry && cache.get(key);
            if (!payload) {
                if (!pending.has(key)) {
                    const controller = new AbortController();
                    const timeout = setTimeout(() => controller.abort(), 15000);
                    const request = fetch(`${registry.dataset.optionsUrl}?${key}`, {
                        signal: controller.signal,
                        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
                    })
                        .then(async response => {
                            if (!response.ok) throw new Error(`HTTP ${response.status}`);
                            const data = await response.json();
                            if (data.facet !== facet || !Array.isArray(data.options)) throw new Error('Invalid filter response');
                            cache.set(key, data);
                            return data;
                        }).finally(() => { clearTimeout(timeout); pending.delete(key); });
                    pending.set(key, request);
                }
                payload = await pending.get(key);
            }
            if (host.dataset.generation !== generation || key !== requestKey(facet)) return;
            render(host, payload);
            host.dataset.loadedKey = key;
        } catch (error) {
            if (host.dataset.generation !== generation) return;
            delete host.dataset.loadedKey;
            host.innerHTML = '<span role="alert">Could not load options. </span><button type="button" class="btn btn-sm btn-outline-secondary" data-retry-gallery-options>Retry</button>';
            throw error;
        } finally {
            if (host.dataset.generation === generation) host.removeAttribute('aria-busy');
        }
    }

    window.loadGalleryFilterOptions = async scope => {
        const hosts = (scope || document).querySelectorAll('[data-gallery-facet]');
        await Promise.all(Array.from(hosts, host => load(host)));
    };
    const open = host => load(host).catch(() => {});
    document.addEventListener('click', event => {
        const clear = event.target.closest('[data-clear-gallery-facet], .fbar-loc-clear, .fbar-svc-clear, .fbar-cat-clear, .fbar-bust-clear, .fbar-age-clear, .fbar-domination-clear');
        if (clear) {
            event.preventDefault();
            event.stopImmediatePropagation();
            const key = clear.dataset.clearGalleryFacet || Object.entries({
                incall_location: 'fbar-loc-clear', services: 'fbar-svc-clear', category: 'fbar-cat-clear',
                busts: 'fbar-bust-clear', ages: 'fbar-age-clear', fetishes: 'fbar-domination-clear'
            }).find(([, name]) => clear.classList.contains(name))?.[0];
            if (key) {
                if (['prices', 'ages'].includes(key)) {
                    rangeEdits[key] = [];
                    document.querySelectorAll(`[data-gallery-facet="${key}"] input[type="number"]`).forEach(input => {
                        input.value = input.name.endsWith('_min') ? input.min : input.max;
                    });
                }
                window.clearGalleryFacet?.(key);
                syncLabels();
            }
            return;
        }
        if (event.target.closest('[data-retry-filter-panel]')) {
            window.ensureGalleryFilterPanel?.().catch(() => {});
            return;
        }
        const retry = event.target.closest('[data-retry-gallery-options]');
        if (retry) { load(retry.closest('[data-gallery-facet]'), true).catch(() => {}); return; }
        const toggle = event.target.closest('.fbar-feature-btn, [data-bs-toggle="dropdown"], [data-sidebar-dropdown]');
        toggle?.closest('.fbar-dropdown')?.querySelectorAll('[data-gallery-facet]').forEach(open);
        if (event.target.closest('.clear_filter, .fbar-drawer-reset')) {
            Object.keys(rangeEdits).forEach(key => { rangeEdits[key] = []; });
            setTimeout(syncLabels, 0);
        }
    }, true);
    document.addEventListener('show.bs.dropdown', event => {
        event.target.closest('.fbar-dropdown')?.querySelectorAll('[data-gallery-facet]').forEach(open);
    });
    document.addEventListener('toggle', event => {
        if (event.target.matches('details[data-gallery-facet-section]') && event.target.open) {
            event.target.querySelectorAll('[data-gallery-facet]').forEach(open);
        }
    }, true);
    document.addEventListener('input', event => {
        const input = event.target;
        if (!input.matches('.filter-list input')) return;
        const key = Object.keys(fields).find(key => fields[key][1] && input.name === fields[key][1]);
        if (key && input.type === 'checkbox') {
            canonicalInput(key, input.value, input.dataset.smartLabel).checked = input.checked;
            document.querySelectorAll(`input[name="${fields[key][1]}"]`).forEach(other => {
                if (other.value === input.value) other.checked = input.checked;
            });
        }
        if (input.matches('.price, .age')) {
            const facet = input.matches('.price') ? 'prices' : 'ages';
            const names = facet === 'prices' ? ['price_min', 'price_max'] : ['age_min', 'age_max'];
            const scope = input.closest('[data-gallery-facet]') || document;
            document.querySelectorAll('input[type="number"]').forEach(other => {
                if (other.name === input.name) other.value = input.value;
            });
            const bounds = names.map((name, index) => {
                const node = scope.querySelector(`input[name="${name}"]`);
                return node?.value || (index ? node?.max : node?.min) || '';
            });
            rangeEdits[facet] = Number(bounds[0]) <= Number(bounds[1]) ? bounds : [];
        }
        clearTimeout(refreshTimer);
        refreshTimer = setTimeout(() => {
            syncLabels();
            document.querySelectorAll('[data-gallery-facet]').forEach(host => {
                const visible = host.closest('details')?.open || host.closest('.dropdown-menu')?.classList.contains('show')
                    || host.closest('.fbar-dropdown')?.querySelector('[aria-expanded="true"]');
                if (visible && host.dataset.galleryFacet !== key) open(host);
            });
        }, 600);
    }, true);
    document.addEventListener('gallery:cards-updated', () => {
        Object.keys(rangeEdits).forEach(key => { delete rangeEdits[key]; });
        setTimeout(() => {
            syncLabels();
            document.querySelectorAll('[data-gallery-facet]').forEach(host => {
                if (host.closest('details')?.open || host.closest('.fbar-dropdown')?.querySelector('[aria-expanded="true"]')) open(host);
            });
        }, 0);
    });
    window.addEventListener('popstate', () => setTimeout(() => {
        // Keep a shared URL's selections even if their option lists have never been opened.
        const params = new URLSearchParams(window.location.search);
        Object.keys(fields).filter(key => fields[key][1]).forEach(key => {
            (params.get(key) || '').split(',').filter(Boolean).forEach(value => { canonicalInput(key, value).checked = true; });
        });
        syncLabels();
    }, 0));
    syncLabels();
})();
